export const symbols = {
  UNDO_REDO_SPLASH: '@@undo-splash',
};

export function setDisplaySplash(isDisplaySplash) {
  return (dispatch) => {
    dispatch({ type: symbols.UNDO_REDO_SPLASH, payload: isDisplaySplash });
  }
}